// GENERATED by tools/assets/build_tiles.py — do not edit by hand.
// Indices into /assets/seven-dawns/tiles.png (16px, 16 columns, no margin).

export const SEVEN_DAWNS_SHEET_COLUMNS = 16;
export const SEVEN_DAWNS_SHEET_ROWS = 5;

export const SEVEN_DAWNS_TILES = {
  water0: 0,
  water1: 1,
  water2: 2,
  water3: 3,
  water4: 4,
  water5: 5,
  water6: 6,
  water7: 7,
  water8: 8,
  water9: 9,
  water10: 10,
  water11: 11,
  water12: 12,
  water13: 13,
  water14: 14,
  water15: 15,
  shallows0: 16,
  shallows1: 17,
  shallows2: 18,
  shallows3: 19,
  shallows4: 20,
  shallows5: 21,
  shallows6: 22,
  shallows7: 23,
  shallows8: 24,
  shallows9: 25,
  shallows10: 26,
  shallows11: 27,
  shallows12: 28,
  shallows13: 29,
  shallows14: 30,
  shallows15: 31,
  waterCornerNE: 32,
  waterCornerSE: 33,
  waterCornerSW: 34,
  waterCornerNW: 35,
  bridgeNS: 36,
  bridgeEW: 37,
  hill: 38,
  hillSmall: 39,
  duneArid: 40,
  hillArid: 41,
  rockGround0: 42,
  rockGround1: 43,
  rockGroundArid: 44,
  peakTL: 45,
  peakTR: 46,
  peakBL: 47,
  peakBR: 48,
  peakSmall: 49,
  peakSmallArid: 50,
  marshPuddle0: 51,
  marshPuddle1: 52,
  marshReeds0: 53,
  marshReeds1: 54,
  marshGround: 55,
  aridTree: 56,
  aridCactus: 57,
  aridCactusSmall: 58,
  aridShrub: 59,
  aridSpire: 60,
  relic: 61,
  leyCrystal: 62,
  bannerAzure: 63,
  bannerEmber: 64,
  bannerTeal: 65,
  bannerNeutral: 66,
  baseAzure: 67,
  baseTeal: 68,
  baseEmber: 69,
  baseGold: 70,
  raven: 71,
  scroll: 72,
  sparks: 73,
  swords: 74,
} as const;

export type SevenDawnsTileName = keyof typeof SEVEN_DAWNS_TILES;
